/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';

import { getIsMobile } from '../../state/site/selectors';
import { FOLLOWING_FOLLOWERS } from '../../constants/app-components';

import styles from './empty-states.scss';

interface Props {
  title: string;
  content: string | React.ReactNode;
  className?: string;
  noBoxClass?: boolean;
  isMobile: boolean;
  appComponent?: string;
}

const EmptyStates: FC<Props> = ({
  title,
  content,
  className,
  children,
  noBoxClass = false,
  isMobile,
  appComponent,
}) => {
  // To Do: refactor this to not know about app component
  const containerClassName = classNames(
    { 'ma-box': !noBoxClass },
    isMobile ? styles.mobile : styles.desktop,
    styles.container,
    className,
    appComponent === FOLLOWING_FOLLOWERS && styles.ff,
    'ma-primary-font-color',
  );

  return (
    <div data-hook="es-content" className={containerClassName}>
      <div className={classNames(styles.headerCont, 'ma-font-body-m')}>
        <div className={classNames(styles.header)}>{title}</div>
      </div>
      <div className={classNames(styles.content, 'ma-font-body-m')}>{content}</div>
      {children && <div className={styles.controls}>{children}</div>}
    </div>
  );
};

export default connect((state: any) => ({ isMobile: getIsMobile(state) }))(EmptyStates);
